<template>
  <div class="page-container">
    <page-header />
    <div class="page-content">
      <div class="icon-wrapper">
        <img
          class="icon"
          src="@/assets/images/hammer-wrench.svg"
          alt="maintenance"
        />
      </div>

      <h3 class="title">
        {{ $t("common.maintenanceMode.title") }}
      </h3>

      <p>
        <strong>{{ $t("common.maintenanceMode.subTitle") }}</strong>
      </p>

      <p>
        {{ description }}
      </p>

      <p>
        <a href="mailto:fleet@mobiliti.hu">fleet@mobiliti.hu</a>
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import PageHeader from "../components/ui/PageHeader.vue"
import { useDictionaryStore } from "@/store/dictionary"
import { storeToRefs } from "pinia"
import { computed } from "vue"
import { useI18n } from "vue-i18n"

export type Language = "en" | "hu"

const { locale } = useI18n()
const dictionaryStore = useDictionaryStore()
const { dynamicConfig } = storeToRefs(dictionaryStore)

const description = computed(() => {
  const lang = locale.value as Language
  return dynamicConfig?.value?.maintenanceMode.description?.[lang]
})
</script>

<style scoped lang="scss">
.page-content {
  display: flex;
  align-items: center;
  text-align: center;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 4rem;
  padding: 0 1.5rem;

  p {
    font-size: 1rem;
    color: $color-text-primary;
  }
}

.icon-wrapper {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background-color: $maintenance-mode-icon-background;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  width: 44px;
  height: 44px;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.title {
  margin-top: 1rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: $color-text-primary;
}

@media (prefers-color-scheme: dark) {
  .page-container {
    p,
    h3 {
      color: $color-text-primary-dark;
    }
  }

  .icon-wrapper {
    background-color: $maintenance-mode-icon-background-dark;
  }

  .icon {
    filter: none;
  }
}
</style>
